import { reduxForm } from 'redux-form'
import submit from './submit'
import validate from './validate'

export interface IChangePasswordValues {
  oldPassword: string
  newPassword: string
  newPasswordAgain: string
  click: () => void
}

export default reduxForm<any, any, any>({
  destroyOnUnmount: true,
  enableReinitialize: true,
  form: 'changePassword',
  onSubmit: submit,
  validate,
})
